// extracted by css-extract-rspack-plugin
var _1 = "bmGGVlIsPNQTWLE_";
export { _1 as "manualPopoverFloating" }
